// Centralized UI constants for routes, text, and images.
// Keeps strings and routes in one place for easy maintenance and security (avoid inline secrets).

export const ROUTES = {
  kundli: '/kundli',
  pooja: '/pooja',
  moon: '/moon',
  chat: '/chat',
  submuhrat: '/submuhrat',
  horoscope: '/horoscope',
  call: '/call',
  credits: '/credits',
  refer: '/refer',
};

export const TEXTS = {
  welcome: 'Welcome',
  tagline: 'Unlock the secrets of the universe with personalized Vedic wisdom',
  chatNow: 'Chat Now!',
  chatSubtitle: 'Get AI Personalized Guidance!',
  bookAppointment: 'Book Appointment',
  callSubtitle: 'Personalized Astro Guidance!',
};

export const IMAGES = {
  chatBg: '/uploads/chat.jpg',
  logo: '/uploads/logo.png',
};